import { withInstall } from '@vuemap/vue-amap-util'
import WMTS from './WMTS.vue'

export const ElAmapLayerWmts = withInstall(WMTS)
export default ElAmapLayerWmts
